//

import cookie from 'cookie';

export default {
    fetch: function fetch(_ref) {
        var params = _ref.params,
            redirect = _ref.redirect;

        if (process.client) {
            var parsedCookies = cookie.parse(document.cookie);
            var utmLang = parsedCookies.utm_language ? parsedCookies.utm_language : 'en';

            redirect(301, '/' + utmLang);
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/unsubscribe.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/unsubscribe.vue
// module chunks = 44